import React from 'react'

const Faq = () => {
  return (
    <div
      style={{
        textAlign: "center",
        width: "1150px",
        maxwidth: "1800px",
        margin: "0 auto",
        color: "#000099",
      }}
    >
      <h1>Frequently Asked Question</h1>
      <div
        style={{
          fontSize: "30px",
        }}
      >
        <p>Is PayLink a registered bank?</p>
        <p>
          We are fostering a culture of saving and investing among the
          millennials and the increasing underrepresented middle class in
          Nigeria.
        </p>
        <p>
          So, whatever you are and wherever you are in Nigeria, you are the
          reason we are. We will improve things so that they are easier for
          everyone to use because we are aware of the difficulty involved in
          utilizing a traditional bank.
        </p>
      </div>
    </div>
  );
}

export default Faq